module.exports = __webpack_public_path__ + "static/staticbox-db88f0834b9e9450070847375e8af333.jpg";